<template>
  <div class="stationNewsDateils-all-box">
    <div class="title">{{ messageInfo.title }}</div>
    <div class="time">{{ messageInfo.createTime }}</div>
    <!-- <div class="content">{{ messageInfo.content }}</div> -->
    <div class="tinymce-content" v-html="messageInfo.content"></div>
    <div class="btn-box">
      <cus-btn type="return" @click="cancel" />
    </div>
  </div>
</template>

<script>
import { sysNoticeSelectDetail } from '../../api/adminManagement'
export default {
  name: 'StationNewsDateils',
  components: {},
  data() {
    return {
      messageInfo: '',
      messageId: ''
    }
  },
  mounted() {
    const self = this
    window.stationNewsDateils = self
    self.messageId = self.$route.query.messageId
    self.getSysNoticeSelectDetail()
  },
  methods: {
    /**
    * 获取消息详情
    */
    getSysNoticeSelectDetail() {
      const self = this
      sysNoticeSelectDetail({ id: self.messageId }).then(response => {
        if (response.code === 200) {
          self.messageInfo = response.data || ''
        }
      })
    },

    /**
    * 返回上一页
    */
    cancel() {
      this.$router.push({
        name: this.$route.query.backToPage,
        query: {
          activeName: this.$route.query.activeName
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.stationNewsDateils-all-box {
    padding: 50px 70px;
    .title {
        font-size:20px;
        font-weight:bolder;
        color:rgba(51,51,51,1);
        margin-bottom: 22px;
    }
    .time {
        font-size:14px;
        color:rgba(153,153,153,1);
        margin-bottom: 28px;
    }

    .tinymce-content {
        font-size:16px;
        color:rgba(102,102,102,1);
    }

    .btn-box {
        text-align: center;
        margin-top: 100px;
    }
}

</style>

<style>

.tinymce-content table{
  border-collapse:collapse;
}

.tinymce-content table td,.tinymce-content table th{
  border:1px solid #ccc;
  padding:.4rem;
}</style>